import { Mapper } from "../../../../base/utils/mapper";
import { DocumentsResponseModel } from "../../../../domain/models/consult/documents-response.model";
import { DocumentsResponseEntity } from '../entities/documents-response.entity';

export class DocumentsImplementationRepositoryMapper extends Mapper<DocumentsResponseEntity, DocumentsResponseModel> {
    mapFrom(param: DocumentsResponseEntity): DocumentsResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DocumentsResponseModel): DocumentsResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}